'use client';

import Link from 'next/link';
import { type Locale, i18n } from '@/lib/config/i18n-config';
import { usePathname } from 'next/navigation';
import { useEffect, useRef, useState } from 'react';

export function LocaleSelector() {
  const menuRef = useRef<HTMLDivElement>(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    function handleOutsideClick(event: MouseEvent) {
      if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
        setVisible(false);
      }
    }

    document.addEventListener('click', handleOutsideClick);

    return () => document.removeEventListener('click', handleOutsideClick);
  });

  const pathName = usePathname();
  const segments = pathName.split('/');
  const currentLocale = segments[1];

  function redirectedPathName(locale: Locale) {
    if (!pathName) return '/';
    segments[1] = locale;
    return segments.join('/');
  }

  return (
    <div className="relative">
      <button
        onClick={() => setVisible((prev) => !prev)}
        className="flex items-center space-x-2 px-4 h-10 rounded-full border border-outline text-primary cursor-pointer hover:bg-primary hover:text-on-primary"
      >
        <i className={`w-4 h-4 flag-${currentLocale}`} />{' '}
        <span>{currentLocale.toUpperCase()}</span>
      </button>

      <div ref={menuRef} className="relative mt-1">
        {visible && (
          <ul className="p-1 border border-outline bg-surface rounded-lg absolute top-0 right-0">
            {i18n.locales.map((locale) => (
              <li
                key={locale}
                className="transition-colors hover:bg-surface-container-high hover:text-on-surface rounded-md"
              >
                <Link
                  href={redirectedPathName(locale)}
                  className="px-2 py-1 flex items-center space-x-2"
                >
                  <i className={`w-4 h-4 flag-${locale}`} />{' '}
                  <span className="text-base">
                    {i18n.localeDetails[locale].name}
                  </span>
                </Link>
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
}
